import React from "react";
import ImageLinks from "./assets/Images/ImagesLink";
import { useTranslation } from "react-i18next";

const Footer = ({ bottom = 0, bottom_safe_area = true, reserveSpace = true }) => {
  const safeArea = bottom_safe_area ? "env(safe-area-inset-bottom)" : "0px";
  const footerHeight = "36px";
  const spacerHeight = `calc(${bottom}rem + ${safeArea} + ${footerHeight})`;
  const { t } = useTranslation();

  return (
    <>
      {reserveSpace && <div aria-hidden style={{ height: spacerHeight }} />}
      <div
        className={`flex flex-row gap-2 text-center py-2 justify-center fixed bottom-10 left-1/2 transform -translate-x-1/2 w-full z-1000 bg-white`}
        style={{ bottom: `calc(${bottom}rem + ${safeArea})` }}
      >
        <p className="text-sm text-gray">{t('powered_by')}</p>
        <img
          loading="lazy"
          src={ImageLinks.pidge_gray_logo}
          alt=""
          className="object-contain shrink-0 aspect-[2.38] w-[38px]"
        />
      </div>
    </>
  );
};

export default Footer;
